module.exports = __webpack_public_path__ + "static/media/TomaszKasprowicz.ff783fe8.pdf";